import {Component, Inject} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../../../core/configs/app-config';
import { PlanningMdwBewerkenDialog } from '../bewerkendialog/bewerkendialog';
import {UserService } from "../../../../core/services/user.service";


@Component({
    selector: 'keuze-dialog',
    templateUrl: 'keuzedialog.component.html',
    styleUrls  : ['./keuzedialog.component.scss']
  })
  export class PlanningMdwKeuzeDialog {
    private headers: Headers = new Headers({ "Content-Type": "application/json",
    "Authorization": this.userService.getAuthenticationtoken() });
    config: any;
    rbKeuze: number;
    constructor(public dialog: MatDialog,public dialogRef: MatDialogRef<PlanningMdwKeuzeDialog>, private userService:UserService, @Inject(MAT_DIALOG_DATA) public data:  any[], @Inject(HttpClient) private http?: HttpClient) {
      this.config = {
        "SERVERPROTOCOL": AppConfig.ApiProtocol,
        "SERVERURL": AppConfig.ApiLoginHost,
        "SERVERPORT": AppConfig.ApiPort,
        "APPLICATIONID": AppConfig.ApiApplicationId,
        "METHOD": AppConfig.ApiMethod,
        "LOGINURL": AppConfig.ApiLoginUrl,
        "STACKURL": AppConfig.ApiUrl
      };
      
      
    }

    btnNext(){
      if(this.rbKeuze == 1){
        const dialogRefBewerken = this.dialog.open(PlanningMdwBewerkenDialog, {
          disableClose: true,
          data: {calEvent: this.data["calEvent"], onlyToday: true}
        });

        dialogRefBewerken.afterClosed().subscribe(data => {
          this.dialogRef.close();
        });
   
      } else if (this.rbKeuze == 2){
        const dialogRefBewerken = this.dialog.open(PlanningMdwBewerkenDialog, {
          disableClose: true,
          data: {calEvent: this.data["calEvent"], onlyToday: false}
        });

        dialogRefBewerken.afterClosed().subscribe(data => {
          this.dialogRef.close();
        });
      } else {
        this.rbKeuze = 0;
      }
      
     }

     btnCancel(){
      this.dialogRef.close();
     }
  }